"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OutputMetadata;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _moment = _interopRequireDefault(require("moment"));

var _getDisplayBytes = _interopRequireDefault(require("@devsta/get-display-bytes"));

var _formatSeconds = require("@devsta/format-seconds");

require("../styles/_output-metadata.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function getVideoSpecs(element, setDimensions) {
  var videoElement = element;

  if (!videoElement) {
    return;
  }

  videoElement.onloadeddata = function () {
    setDimensions("".concat(videoElement.videoWidth, " x ").concat(videoElement.videoHeight));
  };
}

function OutputMetadata(_ref) {
  var asset = _ref.asset,
      assignedEditor = _ref.assignedEditor;

  var _useState = (0, _react.useState)('Unknown'),
      _useState2 = _slicedToArray(_useState, 2),
      dimensions = _useState2[0],
      setDimensions = _useState2[1];

  if (!asset) {
    return null;
  }

  var metaData = JSON.parse(asset.metaData);
  setTimeout(function () {
    var video = document.querySelector('.player__video');
    getVideoSpecs(video, setDimensions);
  });
  var editorName = assignedEditor ? "".concat(assignedEditor.firstName, " ").concat(assignedEditor.lastName) : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "output-metadata"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
    rounded: true,
    className: "output-metadata__block"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading5: true
  }, "General Information"), /*#__PURE__*/_react.default.createElement("div", {
    className: "output-metadata__block__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "output-metadata__block__content__row"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, "Length"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, (0, _formatSeconds.getMinutes)(metaData.duration))), /*#__PURE__*/_react.default.createElement("div", {
    className: "output-metadata__block__content__row"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, "Edited By"), assignedEditor ? /*#__PURE__*/_react.default.createElement("div", {
    className: "output-metadata__block__content__row output-metadata__block__content__editor"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
    imageUrl: assignedEditor.imageUrl,
    placeholderText: editorName,
    placeholderTextSize: 12,
    width: "30px",
    height: "30px",
    circular: true
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, editorName)) : /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, "N/A")), /*#__PURE__*/_react.default.createElement("div", {
    className: "output-metadata__block__content__row"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, "Uploaded On"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, (0, _moment.default)(asset.createdAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('DD/MM/YYYY [at] h:mma'))))), /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
    rounded: true,
    className: "output-metadata__block"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading5: true
  }, "File Information"), /*#__PURE__*/_react.default.createElement("div", {
    className: "output-metadata__block__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "output-metadata__block__content__row"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, "File Size"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, (0, _getDisplayBytes.default)(metaData.size))), /*#__PURE__*/_react.default.createElement("div", {
    className: "output-metadata__block__content__row"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, "Extension"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, metaData.type.split('/')[1])), /*#__PURE__*/_react.default.createElement("div", {
    className: "output-metadata__block__content__row"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, "Resolution"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true
  }, dimensions)))));
}